"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountryCode = void 0;
var CountryCode;
(function (CountryCode) {
    CountryCode["AFG"] = "G:7R";
    CountryCode["ALB"] = "G:7G";
    CountryCode["DZA"] = "G:7S";
    CountryCode["ASM"] = "G:39";
    CountryCode["AND"] = "G:32";
    CountryCode["AGO"] = "G:82";
    CountryCode["AIA"] = "G:1H";
    CountryCode["ATA"] = "G:AY";
    CountryCode["ATG"] = "G:31";
    CountryCode["ARG"] = "G:60";
    CountryCode["ARM"] = "G:7I";
    CountryCode["ABW"] = "G:AD";
    CountryCode["AUS"] = "G:2H";
    CountryCode["AUT"] = "G:1F";
    CountryCode["AZE"] = "G:4R";
    CountryCode["BHS"] = "G:5E";
    CountryCode["BHR"] = "G:5Q";
    CountryCode["BGD"] = "G:9B";
    CountryCode["BRB"] = "G:8P";
    CountryCode["BLR"] = "G:8B";
    CountryCode["BEL"] = "G:9Y";
    CountryCode["BLZ"] = "G:6C";
    CountryCode["BEN"] = "G:48";
    CountryCode["BMU"] = "G:75";
    CountryCode["BTN"] = "G:8F";
    CountryCode["BOL"] = "G:3J";
    CountryCode["BIH"] = "G:2D";
    CountryCode["BWA"] = "G:61";
    CountryCode["BVT"] = "G:6F";
    CountryCode["BRA"] = "G:26";
    CountryCode["IOT"] = "G:9R";
    CountryCode["BRN"] = "G:80";
    CountryCode["BGR"] = "G:1W";
    CountryCode["BFA"] = "G:5A";
    CountryCode["BDI"] = "G:68";
    CountryCode["KHM"] = "G:9G";
    CountryCode["CMR"] = "G:4I";
    CountryCode["CAN"] = "G:8W";
    CountryCode["CPV"] = "G:AF";
    CountryCode["CYM"] = "G:4J";
    CountryCode["CAF"] = "G:5G";
    CountryCode["TCD"] = "G:A6";
    CountryCode["CHL"] = "G:4M";
    CountryCode["CHN"] = "G:B1";
    CountryCode["CXR"] = "G:5R";
    CountryCode["CCK"] = "G:67";
    CountryCode["COL"] = "G:2S";
    CountryCode["COM"] = "G:99";
    CountryCode["COD"] = "G:8A";
    CountryCode["COG"] = "G:5K";
    CountryCode["COK"] = "G:1L";
    CountryCode["CRI"] = "G:5H";
    CountryCode["HRV"] = "G:5X";
    CountryCode["CUB"] = "G:7X";
    CountryCode["CYP"] = "G:8T";
    CountryCode["CZE"] = "G:2E";
    CountryCode["DNK"] = "G:19";
    CountryCode["DJI"] = "G:6Z";
    CountryCode["DMA"] = "G:8U";
    CountryCode["DOM"] = "G:76";
    CountryCode["ECU"] = "G:8Q";
    CountryCode["EGY"] = "G:3G";
    CountryCode["SLV"] = "G:AB";
    CountryCode["GNQ"] = "G:5L";
    CountryCode["ERI"] = "G:6K";
    CountryCode["EST"] = "G:9D";
    CountryCode["SWZ"] = "G:7H";
    CountryCode["ETH"] = "G:6L";
    CountryCode["FLK"] = "G:3L";
    CountryCode["FRO"] = "G:24";
    CountryCode["FJI"] = "G:3Z";
    CountryCode["FIN"] = "G:90";
    CountryCode["FRA"] = "G:5M";
    CountryCode["GUF"] = "G:3B";
    CountryCode["PYF"] = "G:54";
    CountryCode["ATF"] = "G:9V";
    CountryCode["GAB"] = "G:69";
    CountryCode["GMB"] = "G:77";
    CountryCode["GEO"] = "G:9F";
    CountryCode["DEU"] = "G:3D";
    CountryCode["GHA"] = "G:5N";
    CountryCode["GIB"] = "G:79";
    CountryCode["GRC"] = "G:6A";
    CountryCode["GRL"] = "G:2R";
    CountryCode["GRD"] = "G:9A";
    CountryCode["GLP"] = "G:4Q";
    CountryCode["GUM"] = "G:2Y";
    CountryCode["GTM"] = "G:96";
    CountryCode["GGY"] = "G:34";
    CountryCode["GIN"] = "G:9L";
    CountryCode["GNB"] = "G:9Z";
    CountryCode["GUY"] = "G:44";
    CountryCode["HTI"] = "G:22";
    CountryCode["HMD"] = "G:4W";
    CountryCode["HND"] = "G:AG";
    CountryCode["HKG"] = "G:3H";
    CountryCode["HUN"] = "G:46";
    CountryCode["ISL"] = "G:6I";
    CountryCode["IND"] = "G:5B";
    CountryCode["IDN"] = "G:25";
    CountryCode["IRN"] = "G:56";
    CountryCode["IRQ"] = "G:8G";
    CountryCode["IRL"] = "G:6X";
    CountryCode["IMN"] = "G:35";
    CountryCode["ISR"] = "G:3S";
    CountryCode["ITA"] = "G:5J";
    CountryCode["JAM"] = "G:1G";
    CountryCode["JPN"] = "G:41";
    CountryCode["JEY"] = "G:33";
    CountryCode["JOR"] = "G:1Z";
    CountryCode["KAZ"] = "G:85";
    CountryCode["KEN"] = "G:70";
    CountryCode["KIR"] = "G:7P";
    CountryCode["PRK"] = "G:AE";
    CountryCode["KOR"] = "G:83";
    CountryCode["KWT"] = "G:7Q";
    CountryCode["KGZ"] = "G:8R";
    CountryCode["LAO"] = "G:8L";
    CountryCode["LVA"] = "G:4H";
    CountryCode["LBN"] = "G:64";
    CountryCode["LSO"] = "G:2M";
    CountryCode["LBR"] = "G:3U";
    CountryCode["LBY"] = "G:6W";
    CountryCode["LIE"] = "G:A9";
    CountryCode["LTU"] = "G:8I";
    CountryCode["LUX"] = "G:7M";
    CountryCode["MAC"] = "G:3I";
    CountryCode["MKD"] = "G:AI";
    CountryCode["MDG"] = "G:7Z";
    CountryCode["MWI"] = "G:6G";
    CountryCode["MYS"] = "G:8S";
    CountryCode["MDV"] = "G:6H";
    CountryCode["MLI"] = "G:3V";
    CountryCode["MLT"] = "G:4G";
    CountryCode["MHL"] = "G:36";
    CountryCode["MTQ"] = "G:8C";
    CountryCode["MRT"] = "G:2X";
    CountryCode["MUS"] = "G:9N";
    CountryCode["MEX"] = "G:2V";
    CountryCode["FSM"] = "G:9E";
    CountryCode["MDA"] = "G:6P";
    CountryCode["MCO"] = "G:88";
    CountryCode["MNG"] = "G:66";
    CountryCode["MNE"] = "G:3E";
    CountryCode["MSR"] = "G:1X";
    CountryCode["MAR"] = "G:8X";
    CountryCode["MOZ"] = "G:2B";
    CountryCode["MMR"] = "G:72";
    CountryCode["NAM"] = "G:6Q";
    CountryCode["NRU"] = "G:8J";
    CountryCode["NPL"] = "G:2J";
    CountryCode["NLD"] = "G:7K";
    CountryCode["NCL"] = "G:2L";
    CountryCode["NZL"] = "G:49";
    CountryCode["NIC"] = "G:AC";
    CountryCode["NER"] = "G:2U";
    CountryCode["NGA"] = "G:6B";
    CountryCode["NIU"] = "G:62";
    CountryCode["NFK"] = "G:7Y";
    CountryCode["NOR"] = "G:3N";
    CountryCode["OMN"] = "G:7B";
    CountryCode["PAK"] = "G:2P";
    CountryCode["PLW"] = "G:2N";
    CountryCode["PSE"] = "G:59";
    CountryCode["PAN"] = "G:4U";
    CountryCode["PNG"] = "G:2G";
    CountryCode["PRY"] = "G:89";
    CountryCode["PER"] = "G:3T";
    CountryCode["PHL"] = "G:7L";
    CountryCode["PCN"] = "G:15";
    CountryCode["POL"] = "G:5Y";
    CountryCode["PRT"] = "G:A3";
    CountryCode["PRI"] = "G:5U";
    CountryCode["QAT"] = "G:51";
    CountryCode["REU"] = "G:6N";
    CountryCode["ROU"] = "G:2Z";
    CountryCode["RUS"] = "G:38";
    CountryCode["RWA"] = "G:AA";
    CountryCode["SHN"] = "G:9S";
    CountryCode["KNA"] = "G:40";
    CountryCode["LCA"] = "G:3A";
    CountryCode["SPM"] = "G:4E";
    CountryCode["VCT"] = "G:3F";
    CountryCode["WSM"] = "G:2F";
    CountryCode["SMR"] = "G:78";
    CountryCode["STP"] = "G:5F";
    CountryCode["SAU"] = "G:92";
    CountryCode["SEN"] = "G:6E";
    CountryCode["SRB"] = "G:7F";
    CountryCode["SYC"] = "G:5C";
    CountryCode["SLE"] = "G:A5";
    CountryCode["SGP"] = "G:7D";
    CountryCode["SVK"] = "G:1C";
    CountryCode["SVN"] = "G:74";
    CountryCode["SLB"] = "G:1Y";
    CountryCode["SOM"] = "G:5D";
    CountryCode["ZAF"] = "G:2I";
    CountryCode["SGS"] = "G:1N";
    CountryCode["SSD"] = "G:C2";
    CountryCode["ESP"] = "G:55";
    CountryCode["LKA"] = "G:1J";
    CountryCode["SDN"] = "G:C1";
    CountryCode["SUR"] = "G:86";
    CountryCode["SJM"] = "G:1M";
    CountryCode["SWE"] = "G:6V";
    CountryCode["CHE"] = "G:30";
    CountryCode["SYR"] = "G:4P";
    CountryCode["TWN"] = "G:7U";
    CountryCode["TJK"] = "G:4N";
    CountryCode["TZA"] = "G:2T";
    CountryCode["THA"] = "G:3R";
    CountryCode["TGO"] = "G:91";
    CountryCode["TKL"] = "G:5P";
    CountryCode["TON"] = "G:8K";
    CountryCode["TTO"] = "G:9T";
    CountryCode["TUN"] = "G:2W";
    CountryCode["TUR"] = "G:8Z";
    CountryCode["TKM"] = "G:42";
    CountryCode["TCA"] = "G:9I";
    CountryCode["TUV"] = "G:2C";
    CountryCode["UGA"] = "G:47";
    CountryCode["UKR"] = "G:71";
    CountryCode["ARE"] = "G:A4";
    CountryCode["GBR"] = "G:7J";
    CountryCode["UMI"] = "G:9W";
    CountryCode["USA"] = "G:6J";
    CountryCode["URY"] = "G:4Y";
    CountryCode["UZB"] = "G:8M";
    CountryCode["VAT"] = "G:8Y";
    CountryCode["VUT"] = "G:9M";
    CountryCode["VEN"] = "G:2K";
    CountryCode["VNM"] = "G:5Z";
    CountryCode["WLF"] = "G:4L";
    CountryCode["ESH"] = "G:4F";
    CountryCode["YEM"] = "G:28";
    CountryCode["ZMB"] = "G:73";
    CountryCode["ZWE"] = "G:52";
})(CountryCode || (exports.CountryCode = CountryCode = {}));
